import BoUserChallengePage from './BoUserChallengePage';

export default BoUserChallengePage;
